module.exports = __webpack_public_path__ + "static/media/moons_dudas_cita-375.7caa2d72.webp";